import React from 'react';
import {
  RocketLaunchIcon,
  WrenchScrewdriverIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

const CultureOffsiteHowToExecute = () => {
  // Get the playbook stages
  const playbook = getPlaybookById('culture-offsite');
  const stages = playbook?.sections.filter(section => 
    section.id.startsWith('stage-')
  ) || [];

  // Define icons for each stage
  const stageIcons = {
    'stage-1': <WrenchScrewdriverIcon className="h-7 w-7 text-primary-light" />,
    'stage-2': <ChatBubbleLeftRightIcon className="h-7 w-7 text-primary-light" />,
    'stage-3': <DocumentTextIcon className="h-7 w-7 text-primary-light" />,
  };

  return (
    <div className="max-w-none text-gray-300">
      <PlaybookSection
        title="How To Execute"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading="h2"
      >
        <div className="prose prose-invert max-w-none space-y-8">
          <p className="text-gray-300 leading-relaxed">
            Culture co-creation is most effective when approached systematically. This playbook provides a step-by-step framework to help you run a successful culture co-creation offsite that will result in meaningful alignment and actionable outcomes. Here's how to approach it:
          </p>
          
          <div className="my-8">
            <StageCards 
              stages={stages} 
              icons={stageIcons}
              playbookId="culture-offsite"
              introText="Clicking into each tile, you will find a mini toolkit for each execution step."
            />
          </div>

        </div>
      </PlaybookSection>
    </div>
  );
};

export default CultureOffsiteHowToExecute; 